import { Injectable, NgZone, Renderer2, RendererFactory2 } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, fromEvent, merge, Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AppService } from '../../app.service';

@Injectable({
    providedIn: 'root'
})
export class IdleService {
    private readonly TIMEOUT = 20 * 60 * 1000; // 20 minutes
    private readonly WARNING_TIME = 30 * 1000; // 30 seconds before logout

    private idleState$ = new BehaviorSubject<boolean>(false);
    private warningState$ = new Subject<void>();

    private logoutTimer: any;
    private warningTimer: any;
    private renderer: Renderer2;

    constructor(
        private router: Router,
        private ngZone: NgZone,
        private service: AppService,
        private rendererFactory: RendererFactory2
    ) {
        this.renderer = this.rendererFactory.createRenderer(null, null);
        this.startWatching();
    }

    private startWatching(): void {
        this.ngZone.runOutsideAngular(() => {
            const events = ['mousemove', 'keydown', 'click', 'scroll'];
            const eventStreams = events.map(event => fromEvent(document, event));

            merge(...eventStreams)
                .pipe(debounceTime(500))
                .subscribe(() => this.resetTimer());

            this.resetTimer();
        });
    }

    private resetTimer(): void {
        if (this.logoutTimer) clearTimeout(this.logoutTimer);
        if (this.warningTimer) clearTimeout(this.warningTimer);

        this.logoutTimer = setTimeout(() => {
            this.idleState$.next(true);
            this.logout();
        }, this.TIMEOUT);

        this.warningTimer = setTimeout(() => {
            this.warningState$.next();
        }, this.TIMEOUT - this.WARNING_TIME);

        this.idleState$.next(false);
    }

    private logout(): void {
        this.service.onLogout();
    }
    onIdle(): Observable<boolean> {
        return this.idleState$.asObservable();
    }
    onWarning(): Observable<void> {
        return this.warningState$.asObservable();
    }
}
